import { BulkActions as e } from "./bulk-actions/primitive/bulk-actions.js";
import { BulkActionsBar as t } from "./bulk-actions/bulk-actions-bar.js";
import { Pagination as n } from "./pagination/primitive/pagination.js";
import { PaginationBar as r } from "./pagination/pagination-bar.js";
import { Table as i } from "./primitive/index.js";
import { TableMobile as a } from "./primitive/mobile.js";
//#region src/table/table.tsx
var o;
(function(t) {
	t.Root = i.Root, t.Body = i.Body, t.Row = i.Row, t.Head = i.Head, t.Cell = i.Cell, t.Header = i.Header, t.LoaderCell = i.LoaderCell, t.Mobile = a, t.BulkActions = e, t.Pagination = n;
})(o ||= {});
//#endregion
export { e as BulkActions, t as BulkActionsBar, n as Pagination, r as PaginationBar, o as Table };
